<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/cnhqQX/tc-custom/9780226772974.jpg?1730578245176" alt="This image is the cover for the book Slayground, The Parker Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Slayground, The Parker Novels
      </h1>
      <p class="bookDescription body article font2">
        <p>The hunter becomes prey, as a heist goes sour and Parker finds himself trapped in a shuttered amusement park, besieged by a bevy of local mobsters, in <i>Slayground</i>. There are no exits from Fun Island. Outnumbered and outgunned, Parker can’t afford a single miscalculation. He’s low on bullets and making it out alive is a long shot—but, as anyone who’s crossed his path knows, no one is better at playing higher stakes with shorter odds.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Richard Stark
      </h2>
      
      <p class="authorDescription body article"><P><B>Richard Stark</B> was one of the many pseudonyms of Donald E. Westlake (1933–2008), a prolific author of noir crime fiction. In 1993, the Mystery Writers of America bestowed the society’s highest honor on Westlake, naming him a Grand Master.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?588fff4a